let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("wE0iQ")).then(() => parcelRequire('km4YR'));